var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgmodal"},[_c('el-carousel',{staticClass:"view"},_vm._l((_vm.url),function(item){return _c('el-carousel-item',{key:item,staticClass:"image"},[_c('el-image',{staticClass:"image",attrs:{"src":item,"fit":"contain"}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }